import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const testimonials = [
  {
    author: '今日头条娱乐频道',
    role: '媒体平台',
    rating: 5,
    title: '2026年度最受欢迎娱乐资讯平台',
    content: '911爆料网凭借其快速、准确、独家的娱乐爆料，已成为中文互联网最具影响力的吃瓜平台之一。其内容质量和时效性在同类平台中遥遥领先。',
    avatarColor: 'bg-primary-500',
  },
  {
    author: '娱乐周刊编辑部',
    role: '行业媒体',
    rating: 5,
    title: '爆料准确率行业领先',
    content: '在众多娱乐资讯平台中，911爆料网的信息核实机制最为完善。其标注已核实的内容，后续被官方证实准确率超过92%，在圈内建立了极高的公信力。',
    avatarColor: 'bg-accent-500',
  },
  {
    author: '资深吃瓜用户 - 小王',
    role: '忠实读者',
    rating: 5,
    title: '每天必刷的吃瓜圣地',
    content: '从朋友推荐得知911爆料网后就再也离不开了，更新速度快，料又多又猛，评论区也很有意思。现在每天早上第一件事就是打开看有没有新瓜。',
    avatarColor: 'bg-secondary-500',
  },
  {
    author: '微博娱乐博主 - 娱乐大事件',
    role: '自媒体博主',
    rating: 4,
    title: '一手料源，抢发利器',
    content: '作为娱乐博主，911爆料网是我最重要的信息来源之一。很多新闻这里比微博热搜还要快，让我能在第一时间为粉丝提供最新资讯。真心推荐！',
    avatarColor: 'bg-foreground-700',
  },
  {
    author: '小红书达人 - 八卦爱好者',
    role: '内容创作者',
    rating: 5,
    title: '吃瓜内容创作的最佳素材库',
    content: '我做的吃瓜整理视频很多素材都来自911爆料网，信息够全够快，评论区网友的讨论也经常给我很多灵感。强烈推荐给所有吃瓜内容创作者！',
    avatarColor: 'bg-primary-500',
  },
  {
    author: '知乎专栏作者 - 理性分析',
    role: '深度写作者',
    rating: 4,
    title: '信息量大，分析角度独到',
    content: '与其他平台不同的是，911爆料网不只是简单爆料，还会提供事件背景、时间线梳理和多角度分析，非常适合我这种需要深度信息的内容创作者。',
    avatarColor: 'bg-accent-500',
  },
];

const stats = [
  { label: '日均活跃用户', value: '150w+', desc: '覆盖全国超过300个城市' },
  { label: '累计爆料数量', value: '10w+', desc: '涵盖娱乐圈、网红圈、社会热点' },
  { label: '内容核实准确率', value: '92.3%', desc: '已核实内容真实率行业领先' },
];

export default function AboutPage() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "911爆料网",
    "alternateName": "91吃瓜黑料网",
    "url": "https://911baoliao.com/",
    "logo": "https://911baoliao.com/logo.png",
    "description": "911爆料网 - 全网独家爆料首发平台，致力于为吃瓜群众提供最快最准的娱乐爆料资讯。了解我们的品牌故事、平台实力与用户口碑。",
    "sameAs": [
      "https://weibo.com/911baoliao",
      "https://mp.weixin.qq.com/911baoliao"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "客服与爆料投稿",
      "availableLanguage": ["Chinese", "Simplified Chinese"]
    }
  };

  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "关于911爆料网",
    "description": "911爆料网 - 全网独家爆料首发平台，致力于为吃瓜群众提供最快最准的娱乐爆料资讯。了解我们的品牌故事、平台实力与用户口碑。",
    "url": "https://911baoliao.com/about",
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://911baoliao.com/" },
        { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "https://911baoliao.com/about" }
      ]
    },
    "mainEntity": {
      "@type": "Organization",
      "name": "911爆料网",
      "foundingDate": "2024",
      "description": "911爆料网成立于2024年，由一群对娱乐资讯充满热情的媒体人共同创建。核心理念是让每一个普通人都能第一时间获取真实、有价值的娱乐资讯。"
    }
  };

  return (
    <>
      <Navbar />
      <main>
        {/* Breadcrumb */}
        <div className="pt-20 bg-background-50 border-b border-background-200/60">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-1.5 text-xs text-foreground-400 py-3" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line w-3.5 h-3.5 flex items-center justify-center"></i>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Brand Declaration */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto text-center">
              <p className="text-xs text-foreground-400 uppercase tracking-wider mb-4">关于911爆料网</p>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 leading-relaxed">
                全网独家爆料首发平台
                <br />
                <span className="font-normal text-xl md:text-2xl text-foreground-600">
                  我们致力于为吃瓜群众提供最快、最准、最全的娱乐爆料资讯。从网红黑料到明星塌房，从今日大瓜到实时追踪，911爆料网始终站在吃瓜第一线。
                </span>
                <span className="ml-2 text-2xl">🔥</span>
              </h1>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="mb-10">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
                平台实力
              </h2>
              <p className="text-xs text-foreground-500 mt-1.5">用数据说话，用事实证明</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-background-50 rounded-lg p-8 text-center border border-background-200/60">
                  <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-3">{stat.value}</div>
                  <div className="text-sm font-semibold text-foreground-900 mb-2">{stat.label}</div>
                  <div className="text-xs text-foreground-500">{stat.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex items-center gap-2 mb-2">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-medium text-accent-600 uppercase tracking-wide">媒体认可</span>
            </div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-1">
              行业口碑 / 用户信赖
            </h2>
            <p className="text-xs text-foreground-500 mb-8">听听大家怎么说911爆料网</p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t, i) => (
                <div key={i} className={`bg-background-50 rounded-lg p-5 border border-background-200/60 ${i >= testimonials.length - 2 ? 'md:opacity-70' : ''}`}>
                  <div className="flex items-center gap-1 mb-2">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i key={j} className={`w-3.5 h-3.5 flex items-center justify-center ${j < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                    ))}
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">{t.title}</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed mb-4">{t.content}</p>
                  <div className="flex items-center gap-3">
                    <div className={`w-8 h-8 rounded-full ${t.avatarColor} flex items-center justify-center text-background-50 text-xs font-bold`}>
                      {t.author.charAt(0)}
                    </div>
                    <div>
                      <div className="text-xs font-semibold text-foreground-800">{t.author}</div>
                      <div className="text-xs text-foreground-400">{t.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-lg mx-auto">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 text-center mb-1">
                联系我们
              </h2>
              <p className="text-xs text-foreground-500 text-center mb-8">
                有料要爆？有合作意向？欢迎随时与我们取得联系
              </p>

              <form
                data-readdy-form="d95mhk2h9roq6qfrc7eg"
                className="space-y-4"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);

                  const honeypotVal = (formData.get('phone_alt') as string || '').trim();
                  if (honeypotVal) {
                    const s = document.getElementById('about-form-success');
                    const err = document.getElementById('about-form-error');
                    if (s) s.classList.remove('hidden');
                    if (err) err.classList.add('hidden');
                    form.reset();
                    return;
                  }

                  const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                  const s = document.getElementById('about-form-success');
                  const err = document.getElementById('about-form-error');
                  const errText = document.getElementById('about-error-text');
                  if (btn) btn.disabled = true;

                  try {
                    const res = await fetch('https://readdy.ai/api/form/d95mhk2h9roq6qfrc7eg', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                    });
                    const body = await res.text();
                    let parsed: Record<string, unknown> = {};
                    try { parsed = JSON.parse(body); } catch { /* */ }

                    if (res.ok && (parsed as { code?: string })?.code === 'OK') {
                      if (s) s.classList.remove('hidden');
                      if (err) err.classList.add('hidden');
                      form.reset();
                    } else {
                      const msg = ((parsed as { meta?: { message?: string } })?.meta?.message) || ((parsed as { message?: string })?.message) || body || '提交失败';
                      if (errText) errText.textContent = typeof msg === 'string' ? msg : String(msg);
                      if (err) err.classList.remove('hidden');
                      if (s) s.classList.add('hidden');
                    }
                  } catch {
                    if (errText) errText.textContent = '网络错误，请稍后重试';
                    if (err) err.classList.remove('hidden');
                    if (s) s.classList.add('hidden');
                  } finally {
                    if (btn) btn.disabled = false;
                  }
                }}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="about-name" className="block text-xs font-medium text-foreground-700 mb-1.5">姓名</label>
                    <input
                      id="about-name"
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-email" className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱</label>
                    <input
                      id="about-email"
                      type="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="about-subject" className="block text-xs font-medium text-foreground-700 mb-1.5">主题</label>
                  <input
                    id="about-subject"
                    type="text"
                    name="subject"
                    required
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
                    placeholder="爆料投稿 / 商务合作 / 其他"
                  />
                </div>
                <div>
                  <label htmlFor="about-message" className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
                  <textarea
                    id="about-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言内容（最多500字）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                </div>
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />
                <button
                  type="submit"
                  className="w-full py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-primary-600"
                >
                  提交留言 <i className="ri-send-plane-line w-4 h-4 inline-flex items-center justify-center ml-1"></i>
                </button>
              </form>
              <div id="about-form-success" className="hidden mt-4 text-sm text-accent-600 font-medium text-center">
                留言已提交成功！我们会尽快回复您。
              </div>
              <div id="about-form-error" className="hidden mt-4 text-sm text-primary-500 font-medium text-center">
                <span id="about-error-text">提交失败，请稍后重试</span>
              </div>
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-6 text-center">
                品牌故事
              </h2>
              <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
                <p>
                  911爆料网成立于2024年，由一群对娱乐资讯充满热情的媒体人共同创建。我们的核心理念是：让每一个普通人都能第一时间获取真实、有价值的娱乐资讯，享受吃瓜的乐趣。
                </p>
                <p>
                  在信息爆炸的时代，真假消息混杂，谣言与真相难辨。911爆料网建立了一套严格的内容审核机制，通过多重信源交叉验证、编辑团队人工审核等方式，确保每一条标注已核实的内容都经得起推敲。
                </p>
                <p>
                  两年多来，我们从一个小团队成长为拥有千万级用户规模的头部娱乐资讯平台。我们用一次次独家爆料证明了自己——多个引发全网热议的重大事件均由911爆料网首发。我们始终相信，真实才是最有力量的。
                </p>
                <p>
                  未来，911爆料网将继续坚持快速、准确、独家的内容理念，用更专业的态度服务每一位吃瓜群众。无论娱乐圈如何变化，我们始终站在吃瓜第一线，为你带来最新、最全、最有料的娱乐资讯。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SEO Structured Data */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify(orgSchema)
        }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify(aboutSchema)
        }} />
      </main>
      <Footer />
    </>
  );
}